import React from "react";

const Footer = () => {
	return (
		<div id="footer">
			<h2
				className="sarala-bold"
				style={{
					paddingLeft: "20px",
				}}
			>
				Textbankr
			</h2>
		</div>
	);
};

export default Footer;
